<abi-spinner *ngIf="loading && useRouting"></abi-spinner>
<form class="d-print-none" *ngIf="!loading && job" role="form" [formGroup]="form">
<div style="position: relative;">

<ng-container *ngTemplateOutlet="tabHeader"></ng-container>

<abi-nav-dropdown [skipFirst]="true" style="position: relative;">
    <abi-back-button></abi-back-button>
    <ul ngbNav #nav="ngbNav" class="nav-pills" [destroyOnHide]="false" [activeId]="activeTab" (navChange)="tabPageChange($event)">
        <li ngbNavItem="back">
            <a ngbNavLink class="text-muted text-nowrap">
                <i class="fas fa-arrow-left" title="Back"></i>
            </a>
            <ng-template ngbNavContent></ng-template>
        </li>
        <li *ngIf="!hiddenTabs.includes('summary')" ngbNavItem="summary">
            <a ngbNavLink translate="Job.Summary"></a>
            <ng-template ngbNavContent>
                <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
                    <div class="col mb-4">
                        <div class="card h-100">
                            <div class="card-body">
                                <h5 class="card-title">{{ 'Customer.Customer' | translate }}</h5>
                                <dl class="row mb-0">

                                    <ng-container *ngIf="showField('Customer.CustomerID')">
                                    <ng-container *hasTranslation="'Customer.CustomerID'">
                                        <ng-container *ngIf="customer?.id">
                                            <dt class="col-md-4 pr-0" translate="Customer.CustomerID"></dt>
                                            <dd class="col-md-8">
                                                {{ customer?.id }}
                                            </dd>
                                        </ng-container>
                                    </ng-container>
                                    </ng-container>

                                    <ng-container *ngIf="showField('Customer.Company')">
                                    <ng-container *hasTranslation="'Customer.Company'">
                                        <ng-container *ngIf="customer?.companyName">
                                            <dt class="col-md-4 pr-0" translate="Customer.Company"></dt>
                                            <dd class="col-md-8">
                                                {{ customer?.companyName }}
                                            </dd>
                                        </ng-container>
                                    </ng-container>
                                    </ng-container>

                                    <ng-container *ngIf="showField('Contact.Company')">
                                    <ng-container *hasTranslation="'Contact.Company'">
                                        <ng-container *ngIf="job?.contact?.companyName">
                                            <dt class="col-md-4 pr-0" translate="Contact.Company"></dt>
                                            <dd class="col-md-8">
                                                {{ job?.contact?.companyName }}
                                            </dd>
                                        </ng-container>
                                    </ng-container>
                                    </ng-container>


                                    <ng-container *ngIf="showField('Contact.Note')">
                                    <ng-container *hasTranslation="'Contact.Note'">
                                        <ng-container *ngIf="job?.contact?.note">
                                            <dt class="col-md-4 pr-0" translate="Contact.Note"></dt>
                                            <dd class="col-md-8">
                                                {{ job?.contact?.note }}
                                            </dd>
                                        </ng-container>
                                    </ng-container>
                                    </ng-container>


                                    <ng-container *ngIf="showField('Contact.Name')">
                                    <dt class="col-md-4 pr-0" translate="Contact.Name"></dt>
                                    <dd class="col-md-8">
                                        <abi-anchor [clickable]="!isPublic" (clickedEvent)="editContact()" [content]="job?.contact | contact: 'nameOnly'"></abi-anchor>
                                    </dd>
                                    </ng-container>

                                    <ng-container *ngIf="showField('Job.Address')">
                                    <dt class="col-md-4 pr-0" translate="Job.Address"></dt>
                                    <dd class="col-md-8">
                                        <div class="row">
                                            <div class="col">
                                                <abi-anchor [clickable]="!isPublic" (clickedEvent)="editAddress()" [content]="(job?.address | address) || emptyNumber" class="line-breaker"></abi-anchor>
                                            </div>
                                            <div class="col-md-4 col-3 text-right">
                                            <a class="btn btn-sm btn-outline-secondary" [map]="job?.address" [title]="'Address.OpenMap' | translate">
                                                <i class="fas fa-fw fa-map-marker"></i>
                                            </a>
                                            </div>
                                        </div>
                                    </dd>
                                    </ng-container>

                                    <ng-container *ngIf="showField('Contact.Mobile')">
                                        <dt class="col-md-4 pr-0" translate="Contact.Mobile"></dt>
                                        <dd class="col-md-8">
                                            <abi-anchor [clickable]="!isPublic" (clickedEvent)="editContact()" [content]="job?.contact?.mobile || emptyNumber"></abi-anchor>
                                            <a *ngIf="job?.contact?.mobile" class="float-right btn btn-sm btn-outline-secondary"
                                                [href]="'tel:' + job?.contact?.mobile"
                                                [title]="'Contact.CallNumber' | translate">
                                                <i class="fas fa-fw fa-phone"></i>
                                            </a>
                                        </dd>
                                    </ng-container>


                                    <ng-container *ngIf="showField('Contact.OfficeHours')">
                                        <dt class="col-md-4 pr-0" translate="Contact.OfficeHours"></dt>
                                        <dd class="col-md-8">
                                            <abi-anchor [clickable]="!isPublic" (clickedEvent)="editContact()" [content]="job?.contact?.officeHours || emptyNumber"></abi-anchor>
                                            <a *ngIf="job?.contact?.officeHours"
                                                class="float-right btn btn-sm btn-outline-secondary"
                                                [href]="'tel:' + job?.contact?.officeHours"
                                                [title]="'Contact.CallNumber' | translate">
                                                <i class="fas fa-fw fa-phone"></i>
                                            </a>
                                        </dd>
                                    </ng-container>


                                    <ng-container *ngIf="showField('Contact.AfterHours')">
                                    <dt class="col-md-4 pr-0" translate="Contact.AfterHours"></dt>
                                    <dd class="col-md-8">
                                        <abi-anchor [clickable]="!isPublic" (clickedEvent)="editContact()" [content]="job?.contact?.afterHours || emptyNumber"></abi-anchor>
                                        <a *ngIf="job?.contact?.afterHours"
                                            class="float-right btn btn-sm btn-outline-secondary"
                                            [href]="'tel:' + job?.contact?.afterHours"
                                            [title]="'Contact.CallNumber' | translate">
                                            <i class="fas fa-fw fa-phone"></i>
                                        </a>
                                    </dd>
                                    </ng-container>


                                    <ng-container *ngIf="showField('Contact.Email')">
                                        <dt class="col-md-4 pr-0" translate="Contact.Email"></dt>
                                        <dd class="col-md-8">
                                            <abi-anchor [clickable]="!isPublic" (clickedEvent)="editContact()" [content]="job?.contact?.emailAddress || emptyNumber"></abi-anchor>
                                            <a *ngIf="job?.contact?.emailAddress"
                                                class="float-right btn btn-sm btn-outline-secondary"
                                                [href]="'mailto:' + job?.contact?.emailAddress + '?subject=Job ' + job.jobId"
                                                [title]="'Contact.SendEmail' | translate">
                                                <i class="fas fa-fw fa-envelope-open"></i>
                                            </a>
                                        </dd>
                                    </ng-container>

                                    <ng-container *hasTranslation="'Customer.Consent'">
                                        <dt class="col-md-4 pr-0" translate="Customer.Consent"></dt>
                                        <dd class="col-md-8">
                                            <ng-container *ngIf="form.get('consent').disabled">
                                                <div class="form-control-plaintext">{{ job?.consent || 'None Selected' }}</div>
                                            </ng-container>
                                            <select *ngIf="!form.get('consent').disabled" formControlName="consent" class="custom-select">
                                                <option value="" disabled selected translate="Customer.ConsentPrompt"></option>
                                                <option value="YES" translate="System.Yes"></option>
                                                <option value="NO" translate="System.No"></option>
                                                <option value="JOB" translate="Job.Dealer"></option>
                                            </select>
                                        </dd>
                                    </ng-container>

                                    <!-- <abi-form-field class="col-12 col-md-4 col-xl-4" labelColClass="col-6" label="Customer.Consent" [errors]="formErrors.consent" [wrap]="true">
                                        <ng-container *ngIf="form.get('consent').disabled">
                                            <div class="form-control-plaintext">{{ job?.consent || 'None Selected' }}</div>
                                        </ng-container>
                                        <select *ngIf="!form.get('consent').disabled" formControlName="consent" class="custom-select">
                                            <option value="" disabled selected translate="Customer.ConsentPrompt"></option>
                                            <option value="YES" translate="System.Yes"></option>
                                            <option value="NO" translate="System.No"></option>
                                            <option value="JOB" translate="Job.Dealer"></option>
                                        </select>
                                    </abi-form-field> -->
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="col mb-4">
                        <div class="card h-100">
                            <div class="card-body">
                                <h5 class="card-title">{{ 'Job.Job' | translate }}</h5>
                                <dl class="row mb-0">
                                    <dt class="col-md-4 pr-0" translate="Job.FaultCodeID"></dt>
                                    <dd class="col-md-8" [abiLookupdisplayValue]="job?.faultCodeId" listName="CodeJobFault"></dd>
                                    <dt class="col-md-4 pr-0" translate="Job.StatusID"></dt>
                                    <dd class="col-md-8">{{ job?.statusId }}</dd>
                                    <dt class="col-md-4 pr-0" translate="Machine.ModelID"></dt>
                                    <dd class="col-md-8">{{ job?.machine?.modelId }}</dd>
                                    <dt class="col-md-4 pr-0" translate="Machine.MachineName"></dt>
                                    <dd class="col-md-8">{{ job?.machine?.name }}</dd>
                                    <ng-container *ngIf="job?.machine?.dealerBranchId">
                                        <dt class="col-md-4 pr-0" translate="Machine.BranchID"></dt>
                                        <dd class="col-md-8" [abiLookupdisplay]="job?.machine?.dealerBranchId" listName="DealerBranch"></dd>
                                    </ng-container>
                                    <ng-container *ngIf="job?.dealerContact | contact: 'companyThenName'">
                                        <dt class="col-md-4 pr-0" translate="Job.Dealer"></dt>
                                        <dd class="col-md-8"><abi-anchor [clickable]="!isReadonly" (clickedEvent)="editDealerContact()" [content]="job?.dealerContact | contact: 'companyThenName'"></abi-anchor></dd>
                                    </ng-container>
                                    <ng-template [ngIf]="job?.contract">
                                        <dt class="col-md-4 pr-0" translate="Job.Contract"></dt>
                                        <dd class="col-md-8">
                                            <a *ngIf="canSeeContract; else contractId"
                                            [routerLink]="['../../contracts', job?.contract?.contractId]">{{ job?.contract?.contractId }}</a>
                                            <ng-template #contractId><a href="." (click)="showContract(job?.contract?.contractId)">{{ job?.contract?.contractId }}</a> </ng-template>
                                        </dd>
                                        <dt class="col-md-4 pr-0" translate="Contract.TypeID"></dt>
                                        <dd class="col-md-8" [abiLookupdisplay]="job?.contract?.typeId" listName="CodeContractType"></dd>
                                        <ng-template [ngIf]="job?.contract?.overdue">
                                            <dt class="col-md-4 pr-0" translate="Contract.Overdue"></dt>
                                            <dd class="col-md-8">{{ job?.contract?.overdue }}</dd>
                                        </ng-template>
                                    </ng-template>
                                    <ng-container *hasTranslation="'Job.CustomerReference'">
                                        <dt class="col-md-4 pr-0" translate="Job.CustomerReference"></dt>
                                        <dd class="col-md-8">{{ job?.customerRef }}</dd>
                                    </ng-container>

                                    <!-- <ng-container *ngIf="showField('Job.PONumber')">
                                    <ng-container *hasTranslation="'Job.PONumber'">
                                        <dt class="col-md-4 pr-0" translate="Job.PONumber"></dt>
                                        <dd class="col-md-8">{{ job?.purchaseOrderNumber }}</dd>
                                    </ng-container>
                                    </ng-container> -->
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="col mb-4">
                        <div class="card h-100">
                            <div class="card-body">
                            <h5 class="card-title">{{ 'Job.Map' | translate }}</h5>
                                <div class="position-relative">
                                    <a [map]="job?.address">
                                        <img *ngIf="job?.address?.gpsCoordinates" class="center-cropped" [src]="googleMapUri + job.address.gpsCoordinates.toString()"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                    <abi-form-field class="col-12 col-md-4 col-xl-4" labelColClass="col-6" label="Customer.Consent" [errors]="formErrors.consent" [wrap]="true">
                        <ng-container *ngIf="form.get('consent').disabled">
                            <div class="form-control-plaintext">{{ job?.consent || 'None Selected' }}</div>
                        </ng-container>
                        <select *ngIf="!form.get('consent').disabled" formControlName="consent" class="custom-select">
                            <option value="" disabled selected translate="Customer.ConsentPrompt"></option>
                            <option value="YES" translate="System.Yes"></option>
                            <option value="NO" translate="System.No"></option>
                            <option value="JOB" translate="Job.Dealer"></option>
                        </select>
                    </abi-form-field>
                </div> -->
                <ng-container *ngTemplateOutlet="statusButtons2; context: {buttons:filterButtons(buttons1), colCount:2, wide: true}">
                </ng-container>
            </ng-template>
        </li>

    <li *ngIf="!hiddenTabs.includes('status')" ngbNavItem="status">
        <a ngbNavLink translate="Job.Status"></a>
        <ng-template ngbNavContent>
          <div class="row mt-2">
            <div class="col-lg-8 col-md-8">
              <div class="row">
                <abi-form-field label="Job.Resource" class="col-md-12" labelColClass="col-md-3" inputColClass="col-sm d-flex align-items-center">
                    <div class="form-control-plaintext py-0" name="something">
                        <div class="row">
                            <div class="col-4">
                                {{ job?.resourceId }}
                                <ng-container *ngIf="!isPublic || techDetailsPubliclyVisible"><br />{{ resource?.contact | contact }}</ng-container>
                            </div>
                            <button *ngIf="resource && (!isPublic || techDetailsPubliclyVisible)" class="ml-1 btn btn-primary" (click)="showResource(job?.resourceId)"><i class="far fa-user fa-fw"></i></button>
                        </div>
                    </div>
                </abi-form-field>

                <abi-form-field label="Job.Booked" class="col-md-12" labelColClass="col-md-3">
                    <div class="input-group">
                        <input [readonly]="true" #bookedDiv [value]="job.booked | date" type="text" class="form-control col-3" aria-describedby="date-booked-button" noBootstrap>
                        <div class="input-group-append" *ngIf="!isPublic && form.enabled">
                            <button type="button" class="btn btn-primary" (click)="schedule()" id="date-booked-button"
                                [attr.title]="'Job.ScheduleTooltip' | translate" [disabled]="!canSchedule()">
                                <i class="fas fa-user-check"></i>
                                {{ 'Job.Schedule' | translate }}
                            </button>
                        </div>
                    </div>
                </abi-form-field>

                <abi-form-field label="Job.Visited" class="col-md-12" labelColClass="col-md-3" inputColClass="col-sm custom-control custom-checkbox d-flex align-items-center">
                    <input formControlName="visited" class="custom-control-input" type="checkbox">
                    <label class="custom-control-label" for="visited">&nbsp;</label>
                </abi-form-field>

                <abi-form-field label="Job.NextAction" class="col-md-12" labelColClass="col-md-3">
                  <div class="btn-toolbar">
                    <div class="btn-group">
                      <button type="button" [disabled]="nextAction.disabled" class="btn btn-sm btn-outline-primary"
                        (click)="onChangeNextAction(-1)">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                      <input type="button" class="btn btn-outline-primary" ngbDatepicker formControlName="nextAction"
                        #currNextAction="ngbDatepicker" (click)="onChangeNextAction()" />

                      <button type="button" [disabled]="nextAction.disabled" class="btn btn-sm btn-outline-primary"
                        (click)="onChangeNextAction(1)">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </abi-form-field>
                <abi-form-field *ngIf="isAdmin" id="closed-form-field" label="Job.Closed" class="col-md-12" labelColClass="col-md-3" inputColClass="custom-control custom-checkbox d-flex align-items-center">
                    <input formControlName="closed" class="custom-control-input" type="checkbox">
                    <label class="custom-control-label" for="closed">&nbsp;</label>
                </abi-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4">
              <ng-container
                *ngTemplateOutlet="statusButtons; context: {buttons:filterButtons(buttons2), colCount:1, wide: false}">
              </ng-container>
            </div>
          </div>
          <div class="row mt-3">
          <div class="col" *ngIf="job?.visits?.length">
            <h4 translate="Job.Visits"></h4>
            <div class="table-responsive">
                <table class="table table-hover table-sm">
                    <thead class="thead-light">
                    <tr>
                        <th translate="Job.Booked"></th>
                        <th translate="Job.Status"></th>
                        <th translate="Job.Visited"></th>
                        <th translate="Job.Resource"></th>
                        <ng-container *ngIf="jobAtBranch">
                            <th translate="JobAtBranch.BranchID"></th>
                            <th translate="JobAtBranch.TimeSlot"></th>
                        </ng-container>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let visit of job?.visits">
                        <td>{{ visit.booked|date }}</td>
                        <td>{{ visit.statusId }}</td>
                        <td>{{ visit.visited|date }}</td>
                        <td>{{ visit.resourceId }}
                        </td>
                        <ng-container *ngIf="jobAtBranch">
                            <td><span [abiLookupdisplay]="visit.dealerBranchId" listName="DealerBranch"></span></td>
                            <td><span>{{ visit.booked | date:'shortTime' }}</span></td>
                        </ng-container>
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
          <div class="col" *ngIf="job?.followUps?.length">
            <h4 translate="Job.FollowUps"></h4>
            <div class="table-responsive">
                <table class="table table-hover table-sm">
                    <thead class="thead-light">
                    <tr>
                        <th translate="JobFollowup.When"></th>
                        <th translate="JobFollowup.Status"></th>
                        <th translate="JobFollowup.Comment"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let followup of job?.followUps">
                        <td>
                        <a *ngIf="followup.statusId === 'OPEN' && !isPublic; else closedfu" href="." (click)="showFollowUp(followup)">{{ formatDate(followup.followUpDate) }}</a>
                        <ng-template #closedfu>{{ formatDate(followup.followUpDate) }}</ng-template>
                        </td>
                        <td>{{ followup.statusId }}</td>
                        <td>{{ followup.comment }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
        </ng-template>
    </li>

    <li ngbNavItem="machine">
        <a ngbNavLink>
            {{ "Job.Model" | translate }}
            <abi-group-status
                [group]="form.controls.machine"
                [name]="'machine'"
                [show]="form.controls.machine.invalid"
            ></abi-group-status>
        </a>
        <ng-template ngbNavContent>

            <abi-machine-master [showUnlock]="canUnlockMachine" [group]="form.controls.machine" [formErrors]="formErrors" class="d-block mt-2" (addJournal)="addMachineJournalEntry($event)">
            </abi-machine-master>

            <abi-loan-unit
                formControlName="machines"
                [job]="job"
                [formErrors]="formErrors"
                [resource]="resource"
                [isPublic]="isPublic"
                [userCanEdit]="userCanEdit"
                (createDeliveryNote)="createDeliveryNote()">
            </abi-loan-unit>
            <!-- <abi-loan-unit-test-bed
                formControlName="machines"
                [job]="job"
                [formErrors]="formErrors"
                [resource]="resource"
                [isPublic]="isPublic"
                [userCanEdit]="userCanEdit"
                (createDeliveryNote)="createDeliveryNote()">
            </abi-loan-unit-test-bed> -->
            <!-- <pre>{{ formErrors | json }}</pre>
            <pre>{{ form.getRawValue().machines | json }}</pre> -->
        </ng-template>
    </li>

    <li *ngIf="!hiddenTabs.includes('codes')" ngbNavItem="codes" formGroupName="codes">
        <a ngbNavLink>
            {{ "Job.Codes" | translate }}
            <abi-group-status
                [group]="form.controls.codes"
                [name]="'codes'"
                [show]="form.controls.codes.invalid"
            ></abi-group-status>
        </a>
        <ng-template ngbNavContent>
            <div class="row mt-2">
                <abi-form-field label="Job.TypeID">
                    <abi-lookup-edit>
                    <input formControlName="typeId"
                        abiTypeahead
                        abiLookup="CodeJobType"
                        [queryPathExtras]="getQueryPathExtras('CodeJobType')"
                        [codeOnly]="true"
                    />
                    </abi-lookup-edit>
                </abi-form-field>
                <abi-form-field label="Job.FaultCodeID">
                    <abi-lookup-edit>
                    <input
                        formControlName="faultCodeId"
                        abiTypeahead
                        abiLookupQuery="CodeJobFault"
                        abiProductHint="Job.FaultCodeIDHint"
                        [filter]="filterFaultCodes"
                        [path]="getQueryPathExtras('CodeJobFault')"
                        [codeOnly]="true"
                    />
                    </abi-lookup-edit>
                </abi-form-field>
                <abi-form-field label="Job.DiagnosticCodeID">
                    <abi-lookup-edit>
                    <input
                        formControlName="diagnosticCodeId"
                        abiTypeahead
                        abiLookupQuery="CodeJobDiagnostic"
                        abiProductHint="Job.DiagnosticCodeIDHint"
                        [filter]="filterDiagnosticCodes"
                        [path]="getQueryPathExtras('CodeJobDiagnostic')"
                        [codeOnly]="true"
                    >
                    </abi-lookup-edit>
                </abi-form-field>
                <abi-form-field label="Job.ComponentCodeID">
                    <abi-lookup-edit>
                    <input
                        formControlName="componentCodeId"
                        abiTypeahead
                        abiLookupQuery="CodeJobComponent"
                        abiProductHint="Job.ComponentCodeIDHint"
                        [filter]="filterComponentCodes"
                        [path]="getQueryPathExtras('CodeJobComponent')"
                        [codeOnly]="true"
                    />
                    </abi-lookup-edit>
                </abi-form-field>
                <abi-form-field label="Job.CloseCodeID">
                    <abi-lookup-edit>
                    <input
                        formControlName="repairCodeId"
                        abiTypeahead
                        abiLookupQuery="CodeJobClose"
                        abiProductHint="Job.CloseCodeIDHint"
                        [filter]="filterCloseCodes"
                        [path]="getQueryPathExtras('CodeJobClose')"
                        [codeOnly]="true"
                    />
                    </abi-lookup-edit>
                </abi-form-field>
                <abi-form-field label="Job.CustomerReference">
                    <input formControlName="customerRef" />
                </abi-form-field>
                <abi-form-field label="Job.OurReference">
                    <input formControlName="ourRef" />
                </abi-form-field>

                <abi-form-field label="Job.PONumber">
                    <input formControlName="purchaseOrderNumber" />
                </abi-form-field>

                <abi-form-field *ngFor="let i of [1,2,3,4,5]" [label]="'Job.Field' + i"
                    [ignoreStatus]="2">
                    <input
                        *ngIf="getString('JobCustomField' + i + 'Lookup') as lookup; else textOnly"
                        type="text"
                        [formControlName]="'field' + i"
                        abiTypeahead
                        [abiLookup]="lookup"
                        [inputDisplay]="getString('JobCustomField' + i + 'LookupInputDisplay') || 'name'"
                        [dropDownDisplay]="getString('JobCustomField' + i + 'LookupDropdownDisplay') || 'name'"
                        [codeOnly]="true"
                    />

                    <ng-template #textOnly>
                        <input type="text" [formControlName]="'field' + i">
                    </ng-template>
                </abi-form-field>
            </div>
            <!-- <pre>
                {{ form.value | json }}
            </pre> -->
        </ng-template>
    </li>

    <li *ngIf="!hiddenTabs.includes('jobLines')" ngbNavItem="jobLines">
        <a ngbNavLink>
            {{ "Job.Lines" | translate }}
            <abi-group-status
                [group]="form.controls.jobLines"
                [name]="'jobLines'"
                [show]="form.controls.jobLines.invalid"
            ></abi-group-status>

        </a>
        <ng-template ngbNavContent>
            <div *ngIf="showSpecialLineEdit" class="d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-primary" (click)="allowSpecialLineEdit = true"><i class="fas fa-unlock"></i> Update Lines</button>
            </div>
            <abi-line
                class="mt-2 d-block"
                [stockParentId]="getQueryPathExtras('StockMaster')"
                [job]="job"
                [resource]="resource"
                [payment]="payment"
                [codJob]="codJob"
                [isReadonly]="!linesEditable"
                [form]="form"
                [formErrors]="formErrors"
                (newLines)="setLines($event)"
                (saveJob)="lineSave()"></abi-line>
        </ng-template>
    </li>

    <li *ngIf="!hiddenTabs.includes('text')" ngbNavItem="text">
        <a ngbNavLink translate="Job.Text"></a>
        <ng-template ngbNavContent>
            <div class="row mt-2">
                <abi-form-field label="Job.FaultDescription" [wrap]="true" [errors]="formErrors.faultDescription" cols="col-12"
                    labelColClass="col-md-2" [extraLabel]="requiredChars('faultDescription', 'JobFaultDescriptionLength')">
                    <textarea rows="4" formControlName="faultDescription" maxlength="1000"></textarea>
                </abi-form-field>
                <abi-form-field *ngIf="!preventEdit" label="Job.NoteInternal" [wrap]="true" cols="col-12"
                    labelColClass="col-md-2"  [errors]="formErrors.noteInternal" [extraLabel]="requiredChars('noteInternal', 'JobNoteInternalLength')">
                    <textarea rows="4" formControlName="noteInternal" maxlength="1000"></textarea>
                </abi-form-field>
                <abi-form-field label="Job.NoteExternal" [errors]="formErrors.noteExternal" [wrap]="true" cols="col-12"
                    labelColClass="col-md-2" [extraLabel]="requiredChars('noteExternal', 'JobNoteExternalLength')">
                    <textarea rows="4" formControlName="noteExternal" maxlength="1000"></textarea>
                </abi-form-field>
                <div class="col-12">
                    <div *ngIf="!preventEdit" formArrayName="journals" class="mt-0 row">
                        <abi-form-field *ngFor="let journal of journals.controls; let i=index" [formGroupName]="i" [wrap]="true" cols="col-12"
                            labelColClass="col-md-2" inputColClass="col-sm" label="Job.NewJournal" [errors]="formErrors[i + '_text']">
                            <div class="input-group w-100">
                                <textarea rows="4" formControlName="text"></textarea>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" *ngIf="i < journals.length - 1"
                                        (click)="deleteJournal(i)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                    <button type="button" class="btn btn-outline-secondary" [disabled]="!journal.valid"
                                        *ngIf="i === journals.length - 1" (click)="addJournal()">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </abi-form-field>
                    </div>
                </div>

            </div>

            <div class="mt-2" *ngIf="job?.messages?.length && userCanEdit">
                <h4 translate="Job.Messages"></h4>
                <div class="table-responsive job-messages">
                    <table class="table table-hover table-sm">
                        <thead class="thead-light">
                        <tr>
                            <th translate="JobMessage.Method"></th>
                            <th translate="Job.TypeID"></th>
                            <th translate="Job.Address"></th>
                            <th translate="JobMessage.Message"></th>
                            <th translate="Job.Status"></th>
                            <th class="w-10" translate="JobMessage.Sent"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let msg of job?.messages">
                            <td>{{ msg.method }}</td>
                            <td>{{ msg.typeId }}</td>
                            <td>{{ msg.address }}</td>
                            <td><div class="small">{{ msg.message }}</div></td>
                            <td>{{ msg.statusId }}</td>
                            <td>{{ msg.sent | date:"y-MM-dd HH:mm:ss" }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>
    </li>

    <li *ngIf="!hiddenTabs.includes('checklist')" ngbNavItem="checklist">
        <a ngbNavLink translate="Checklist.Title"></a>
        <ng-template ngbNavContent>

            <div class="card mb-3" *ngIf="job">
                <div class="card-body pb-0">
                    <h5 class="card-title">
                        {{ 'Checklist.Title' | translate }}
                        <button class="btn btn-sm btn-primary float-right mb-1" (click)="unlockChecklist()" *ngIf="checklistLocked && showUnlock"><i class="fas" [ngClass]="{'fa-lock': checklistLocked, 'fa-lock-open': checklistLocked  }"></i> Update Checklist</button>
                    </h5>
                    <abi-job-checklist [checklistEntry]="job.checklist" [getChecklistDto]="getChecklistDto()" [updateResponse]="updateChecklistResponse()" [uploadFileToServer]="uploadFileToServer()" (viewAttachment)="viewAttachment($event)" (attachmentUploaded)="attachmentUploaded($event)"></abi-job-checklist>
                </div>
                <div class="card-footer text-center">
                    <span class="checklist-checklistId text-muted small">{{ job.checklist?.checklistId }}</span>
                </div>
            </div>
        </ng-template>
    </li>

    <li *ngIf="!hiddenTabs.includes('validation')" ngbNavItem="validation">
        <a ngbNavLink translate="Job.Validation"></a>
        <ng-template ngbNavContent>

            <div class="card mb-3" *ngIf="job?.holds?.length || showAddHold">
                <div class="card-body pb-0">
                    <h5 class="card-title pb-0">
                        {{ "Job.Holds" | translate }} <button *ngIf="showAddHold && !preventEdit" class="btn btn-primary btn-sm float-right" (click)="addHold()" title="New hold"><i class="fas fa-plus fa-fw"></i></button>
                    </h5>

                    <div class="table-responsive" formArrayName="holds">
                        <table class="table table-hover table-sm">
                            <thead class="thead-light">
                                <tr>
                                    <th translate="JobHold.ID" class="w-5"></th>
                                    <th translate="JobHold.TypeID" class="w-30"></th>
                                    <th translate="JobHold.ClearedBy" class="w-10"></th>
                                    <th translate="JobHold.ClearedOn" class="w-10"></th>
                                    <th class=" w-10" translate="JobHold.Status"></th>
                                    <th class="text-right w-10" translate="JobHold.Action"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template ngFor let-hold [ngForOf]="job?.holds" let-i="index">
                                    <tr [formGroupName]="i">
                                        <td>{{ hold.holdId?.substring(1) }}</td>
                                        <td>
                                            <!-- {{ holds.at(i).value | json }}
                                            {{ holds.at(i).status }} -->
                                            <div class="row">
                                                <div class="col-12">
                                                    <input *ngIf="!hold.holdId; else holdText" formControlName="typeId" abiTypeahead abiLookup="CodeHoldType" [preFilter]="holdsFilterFunc()" />
                                                    <ng-template #holdText>
                                                        {{ hold.typeId | lookupvalue: 'CodeHoldType'}}
                                                    </ng-template>
                                                </div>
                                                <ng-template [ngIf]="!hold.clearedUserId && !!holds.value[i].status">
                                                    <!-- <ng-container *ngIf="holdPermission(hold, 'SignOnGlass'); else plainTextHoldInput">
                                                    </ng-container>
                                                    <ng-template #plainTextHoldInput> -->
                                                        <abi-form-field [errors]="formErrors[i + '_text']" [wrap]="true" cols="col-12" class="mt-1">
                                                            <textarea rows="2" formControlName="text" abiProductHint="JobHold.Reason"></textarea>
                                                        </abi-form-field>
                                                    <!-- </ng-template> -->
                                                </ng-template>
                                            </div>
                                        </td>
                                        <td>{{ hold.clearedUserId }}</td>
                                        <td>{{ hold.cleared | date }}</td>
                                        <td class="">
                                            {{ hold.status || holds.value[i].status }}
                                        </td>
                                        <td class="p-1 pr-1 text-right align-middle">
                                            <!-- {{ holds.at(i).status }} -->
                                            <!-- {{ holds.at(i).value | json }} -->
                                            <div class="btn-group">
                                                <ng-container *ngIf="!hold.clearedUserId && canClearHold(hold.typeId); else noClearButtons">
                                                    <ng-container *ngIf="holdPermission(hold, HoldPermission.SIGNATURE); else standardStatusButtons">
                                                        <div class="btn-group">
                                                            <button type="button" class="btn btn-primary" (click)="openSignatureDialog(i)">{{ 'JobHold.Sign' | translate }}</button>
                                                            <button *ngIf="canOverrideSign" type="button" class="btn btn-primary" (click)="backofficeApprove(i)">{{ 'JobHold.Approve' | translate }}</button>
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #standardStatusButtons>
                                                        <div
                                                            class="btn-group btn-group-toggle btn-group-sm"
                                                            name="status"
                                                            ngbRadioGroup
                                                            formControlName="status"
                                                        >
                                                            <label ngbButtonLabel class="btn-outline-success">
                                                                <input ngbButton type="radio" [value]="JobHoldTypes.ACCEPTED" title="Accept"><i class="fas fa-check"></i>
                                                            </label>
                                                            <label ngbButtonLabel class="btn-outline-danger">
                                                                <input ngbButton type="radio" [value]="JobHoldTypes.DECLINED" title="Decline"><i class="fas fa-ban"></i>
                                                            </label>
                                                        </div>
                                                    </ng-template>
                                                </ng-container>
                                                <ng-template #noClearButtons>

                                                    <ng-container *ngIf="holdPermission(hold, 'SignOnGlass') && hold.attachmentId;">
                                                        <button type="button" class="btn btn-primary btn-sm" (click)="openViewerById(hold.attachmentId)"
                                                            [attr.title]="'Attachment.View' | translate">
                                                            <i class="far fa-image"></i>
                                                        </button>
                                                    </ng-container>
                                                    <button *ngIf="hold.status === JobHoldTypes.NEW || (isAdmin && hold.clearedUserId)" type="button" class="btn btn-primary btn-sm" (click)="deleteHold(i)" title="Delete Hold"><i class="fas fa-trash"></i></button>
                                                </ng-template>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                    <!-- <pre>{{ currentHoldGroup?.value | json }}</pre> -->
                    <!-- {{ holds.value | json }} -->
                    <!-- {{ formErrors | json}} -->
                </div>
            </div>

            <div class="mb-3" *ngIf="job?.errors?.length">
                <h5 translate="Job.Errors"></h5>
                <div class="table-responsive">
                    <table class="table table-hover table-sm">
                        <thead class="thead-light">
                        <tr>
                            <th translate="JobError.Code"></th>
                            <th translate="JobError.Data"></th>
                            <th translate="JobError.Text"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let error of job?.errors">
                            <td>{{ error.code }}</td>
                            <td>{{ error.data }}</td>
                            <td>{{ error.description }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="mb-3" *ngIf="job?.validations?.length">
                <h5 translate="Job.Feedback"></h5>
                <div class="table-responsive">
                    <table class="table table-hover table-sm">
                        <thead class="thead-light">
                            <tr>
                                <th translate="Job.Status"></th>
                                <th translate="JobFeedback.Confirmed"></th>
                                <th translate="JobFeedback.Score"></th>
                                <th translate="JobFeedback.ValidationID"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let validation of job?.validations">
                                <td>{{ validation.statusId }}</td>
                                <td>{{ validation.confirmed }}</td>
                                <td>{{ validation.score }}</td>
                                <td>{{ validation.validationId }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="mb-3" *ngIf="job?.edi?.length">
                <h5 translate="Job.Edi"></h5>
                <div class="table-responsive">
                    <table class="table table-hover table-sm">
                        <thead class="thead-light">
                        <tr>
                            <th translate="JobEdi.Id"></th>
                            <th translate="Job.Status"></th>
                            <th translate="JobEdi.Name"></th>
                            <th translate="JobEdi.Transmission"></th>
                            <th translate="JobEdi.Direction"></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of job?.edi">
                            <td>{{ item.ediId}}</td>
                            <td>{{ item.statusId }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.date | date:'y-MM-dd hh:mm:ss' }}</td>
                            <td>{{ item.direction }}</td>
                            <td>
                            <button type="button" *ngIf="extraButton(item) as btn" class="btn btn-primary btn-sm float-right" (click)="extraMenuAction(btn)" [title]="btn.label">
                                <i class="fas fa-level-down-alt"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- <pre>{{ form.value.holds | json }}</pre> -->
        </ng-template>
    </li>

    <li *ngIf="!hiddenTabs.includes('documents')" ngbNavItem="documents">
        <a ngbNavLink translate="Job.Documents"></a>
        <ng-template ngbNavContent>
            <div class="card mb-3">
                <div class="card-body">
                    <!-- <h5 class="card-title pb-0">
                        {{ "Job.Holds" | translate }} <button *ngIf="showAddHold && !preventEdit" class="btn btn-primary btn-sm float-right" (click)="addHold()" title="New hold"><i class="fas fa-plus fa-fw"></i></button>
                    </h5> -->
                    <abi-attachments
                        title="Job Attachments"
                        [hiddenTypes]="hiddenJobAttachmentTypes"
                        [useCheckDigit]="isPublic"
                        [parentId]="job?.jobId"
                        [service]="jobService"
                        [attachments]="job?.attachments"
                        [isReadOnly]="(isPublic && !canPublicUpload) || form.disabled"
                        [allowDelete]="!isPublic"
                        [maxCount]="isPublic ? 10 : 0"></abi-attachments>
                </div>
            </div>

            <ng-container *ngIf="job?.machine?.attachments?.length">
                <div class="card mb-3">
                    <div class="card-body">
                        <abi-attachments
                            title="Machine Attachments"
                            [useCheckDigit]="isPublic"
                            [parentId]="job?.machine?.machineId"
                            [service]="machineService"
                            [attachments]="job?.machine?.attachments"
                            [isReadOnly]="true"
                            [allowDelete]="!isPublic"
                            [maxCount]="isPublic ? 10 : 0"></abi-attachments>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="model?.attachments?.length">
                <div class="card mb-3">
                    <div class="card-body">
                        <abi-attachments
                        title="Model Attachments"
                        [useCheckDigit]="isPublic"
                        [parentId]="job?.machine?.modelId"
                        [service]="modelService"
                        [attachments]="model?.attachments"
                        [isReadOnly]="true"
                        [allowDelete]="false"
                        [maxCount]="isPublic ? 10 : 0"></abi-attachments>
                    </div>
                </div>
            </ng-container>
        </ng-template>
    </li>

      <li *ngIf="!hiddenTabs.includes('details')" ngbNavItem="details">
        <a ngbNavLink translate="Job.Details"></a>
        <ng-template ngbNavContent>
          <div class="row mt-2">
            <div class="col-6">
                <h4 translate="Job.Machine"></h4>
                <mat-divider></mat-divider>
                <dl class="row mt-2">
                    <dt class="col-md-4" translate="Machine.ModelID"></dt>
                    <dd class="col-md-8">{{ job?.machine?.modelId }}</dd>

                    <dt class="col-md-4" translate="Machine.MachineName"></dt>
                    <dd class="col-md-8">{{ job?.machine?.name }}</dd>

                    <dt class="col-md-4" translate="Machine.Serial"></dt>
                    <dd class="col-md-8">{{ job?.machine?.serialNumber }}</dd>

                    <dt class="col-md-4" translate="Machine.DateOfPurchase"></dt>
                    <dd class="col-md-8">{{ job?.machine?.dateOfPurchase|date }}</dd>

                    <dt class="col-md-4" translate="Machine.BranchID"></dt>
                    <dd class="col-md-8" [abiLookupdisplay]="job?.machine?.dealerBranchId" listName="DealerBranch">
                </dl>
            </div>
            <div class="col-6">
                <h4 translate="Job.Resource"></h4>
                <mat-divider></mat-divider>
                <dl class="row mt-2">
                    <dt class="col-md-4" translate="Contact.Name"></dt>
                    <dd class="col-md-8">{{ resource?.contact | contact }}</dd>

                    <dt class="col-md-4" translate="Contact.Company"></dt>
                    <dd class="col-md-8">{{ resource?.contact?.companyName }}</dd>

                    <dt class="col-md-4" translate="Contact.Mobile"></dt>
                    <dd class="col-md-8">{{ resource?.contact?.mobile }}</dd>
                </dl>
            </div>
            <div class="col-6">
                <h4 translate="Job.Dealer"></h4>
                <mat-divider></mat-divider>
                <dl class="row mt-2">
                    <dt class="col-md-4" translate="Contact.Name"></dt>
                    <dd class="col-md-8">{{ job?.dealerContact | contact }}</dd>

                    <dt class="col-md-4" translate="Contact.Company"></dt>
                    <dd class="col-md-8">{{ job?.dealerContact?.companyName }}</dd>

                    <dt class="col-md-4" translate="Contact.OfficeHours"></dt>
                    <dd class="col-md-8">{{ job?.dealerContact?.officeHours }}</dd>

                    <dt class="col-md-4" translate="Contact.Mobile"></dt>
                    <dd class="col-md-8">{{ job?.dealerContact?.mobile }}</dd>

                    <dt class="col-md-4" translate="Contact.Email"></dt>
                    <dd class="col-md-8 pre-wrap">{{ job?.dealerContact?.emailAddress }}</dd>
                </dl>
            </div>
            <div class="col-6">
                <h4 translate="Job.Details"></h4>
                <mat-divider></mat-divider>
                <dl class="row mt-2">
                    <dt class="col-md-4" translate="Job.Source"></dt>
                    <dd class="col-md-8">{{ job?.sourceId }}</dd>

                    <dt class="col-md-4" translate="Job.Logged"></dt>
                    <dd class="col-md-8">{{ job?.logged|date }}</dd>

                    <dt class="col-md-4" translate="Job.Booked"></dt>
                    <dd class="col-md-8">{{ job?.booked|date }}</dd>

                    <dt class="col-md-4" translate="Job.CustomerReference"></dt>
                    <dd class="col-md-8">{{ job?.customerRef }}</dd>

                    <dt class="col-md-4" translate="Job.OurReference"></dt>
                    <dd class="col-md-8">{{ job?.ourRef }}</dd>
                </dl>
            </div>
          </div>
          <div class="mt-3">
            <h4 translate="Job.Journals"></h4>
            <div class="table-responsive">
              <table class="table table-hover table-sm">
                <thead class="thead-light">
                    <tr>
                        <th translate="JobJournal.Date"></th>
                        <th translate="JobJournal.By"></th>
                        <th translate="JobJournal.TypeID"></th>
                        <th translate="JobJournal.Text"></th>
                        <th translate="JobJournal.From"></th>
                        <th translate="JobJournal.To"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let journal of allJournals">
                        <td>
                            <small class="text-nowrap">{{ journal.created|date:'y-MM-dd HH:mm:ss' }}</small>
                        </td>
                        <td>
                            <small>{{ journal.by }}</small>
                        </td>
                        <td>
                            <small [abiLookupdisplay]="journal.typeId" listName="CodeJournalType"></small>
                        </td>
                        <td>
                            <small>{{ journal.text }}</small>
                        </td>
                        <td>
                            <small>{{ journal.from }}</small>
                        </td>
                        <td>
                            <small>{{ journal.to }}</small>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>

            <!-- <h4 translate="Job.MachineJournals"></h4>
            <div class="table-responsive">
              <table class="table table-hover table-sm">
                <thead class="thead-light">
                    <tr>
                        <th translate="JobJournal.Date"></th>
                        <th translate="JobJournal.By"></th>
                        <th translate="JobJournal.TypeID"></th>
                        <th translate="JobJournal.Text"></th>
                        <th translate="JobJournal.From"></th>
                        <th translate="JobJournal.To"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let journal of job?.machine?.journals">
                        <td>
                            <small class="text-nowrap">{{ journal.created|date:'y-MM-dd HH:mm:ss' }}</small>
                        </td>
                        <td>
                            <small>{{ journal.by }}</small>
                        </td>
                        <td>
                            <small [abiLookupdisplay]="journal.typeId" listName="CodeJournalType"></small>
                        </td>
                        <td>
                            <small>{{ journal.text }}</small>
                        </td>
                        <td>
                            <small>{{ journal.from }}</small>
                        </td>
                        <td>
                            <small>{{ journal.to }}</small>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div> -->
          </div>
        </ng-template>
    </li>

    <li *ngIf="(isAdmin || isFinance || isPublic) && codJob" ngbNavItem="cod">
        <a ngbNavLink translate="Job.Cod"></a>
        <ng-template ngbNavContent>
            <abi-cod [useRouting]="false" [boundJob]="job" [boundModel]="model"></abi-cod>
        </ng-template>
    </li>

    <li  *ngIf="(isAdmin || isMan || isPublic) && showValidation" ngbNavItem="closeValidation">
        <a ngbNavLink translate="Job.CloseValidation"></a>
        <ng-template ngbNavContent>
            <abi-validation [useRouting]="false" [boundJob]="job" [check]="isPublic && generateCheckDigit(this.job.jobId) || undefined"></abi-validation>
        </ng-template>
    </li>
</ul>

</abi-nav-dropdown>

</div>

    <div class="mt-2" [ngbNavOutlet]="nav"></div>
</form>

<abi-print [job]="job" [resource]="resource" [model]="model" [customer]="customer" [jobHolds]="holdTypes" [useRouting]="false" [sections]="printSections" [title]="'Job.Print'+selectedPrintOption"></abi-print>

<ng-template #tabHeader>
    <div class="card mb-2">
        <div class="card-header" style="border-bottom: 0;">
            <div class="row">
                <div class="col-6 col-md-4">
                    <h4>{{ job | job:'cleanJobId' }}</h4>
                </div>
                <div class="col-6 col-md-4 order-md-last">
                    <div *ngIf="!showPrint && !userCanEdit" class="float-right">
                        <img class="logo" [src]="'assets/logos-big/' + tenant + '.svg?v=1'" [alt]="tenant" />
                    </div>
                    <div class="btn-toolbar float-right" role="toolbar">
                        <div class="btn-group" role="group">
                            <button *ngIf="userCanEdit" id="send-sms" class="btn btn-primary" type="button" (click)="sendSms()" [title]="'JobMessage.SendSms' | translate"><i class="fas fa-sms fa-lg"></i></button>
                            <button *ngIf="userCanEdit" id="add-followup" class="btn btn-primary" type="button" (click)="addFollowUp()" [title]="'JobFollowup.Add' | translate"><i class="fas fa-tag fa-lg"></i></button>
                            <!--button *ngIf="extraMenu?.length" class="btn btn-primary" type="button" mat-list-item [matMenuTriggerFor]="extrasMenu" [title]="extraLabel"><i class="fas fa-ellipsis-v "></i></button-->

                            <!-- <mat-menu #extrasMenu="matMenu">
                                <button *ngFor="let item of extraMenu"  mat-menu-item (click)="extraMenuAction(item)">
                                    {{ item.label }}</button>
                                </mat-menu> -->
                            <button *ngIf="jobAtBranch && isPublic" id="add-public-followup" class="d-print-none btn btn-primary" type="button" (click)="addPublicFollowUp()" [title]="'JobFollowup.Add' | translate"><i class="fas fa-tag"></i> {{ 'JobFollowup.Add' | translate }}</button>


                            <ng-container *ngIf="printOptions.length > 1; else simplePrint">
                                <div ngbDropdown class="btn-group">
                                    <button type="button" class="btn btn-primary" id="actionsDropdown" ngbDropdownToggle>
                                        <i class="fas fa-print fa-lg"></i> {{ 'System.Print' | translate }}
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="actionsDropdown">
                                        <button *ngFor="let option of printOptions" ngbDropdownItem [title]="'System.Print' | translate" (click)="beforePrint($event, option)">{{ "Job.Print"+option | translate }}</button>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #simplePrint>
                                <button class="btn btn-primary" type="button" (click)="beforePrint($event, 'Default')" [title]="'System.Print' | translate"><i class="fas fa-print fa-lg"></i></button>
                            </ng-template>



                            <ng-container *ngIf="saveButtonsVisible()">
                                <button type="button" [disabled]="!cancelAllowed()"  class="btn btn-danger" (click)="cancelChanges()">
                                    <i class="fas fa-times"></i>
                                </button>
                                <button type="button" [disabled]="!saveAllowed()" class="btn btn-success" (click)="saveChanges()"
                                    data-cy="job-details-save">
                                    <i class="fas fa-check"></i>
                                </button>
                            </ng-container>
                        </div>
                    </div>

                </div>
                <div class="col-12 col-md-4 font-weight-bold" [abiLookupdisplay]="job?.statusId" listName="CodeJobStatus">
                </div>
            </div>
            <div class="row">
                <div class="col">
                  <b>{{ job?.contact | contact }}</b>
                </div>
                <div class="col text-right">
                  <span *ngIf="job?.repeatCount">
                      {{ 'Job.RepeatCount' | translate }} {{ job?.repeatCount }}
                  </span>
                  <span *ngIf="job?.unpaid && showDelivered && codJob">
                      {{ 'Job.Unpaid' | translate }} {{ job?.unpaid?.toFixed(2) }}
                  </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #statusButtons let-buttons="buttons" let-colCount="colCount" let-wide="wide">
    <div *ngIf="!isPublic && form.enabled && !closed.value" class="row" [class.justify-content-between]="wide">
        <div
            *ngFor="let dum of columnGenerator(colCount); let col=index; first as isFirst"
            class="col-12 col-md-12 col-lg-12 pt-md-0"
            [class.pt-2]="!isFirst">
            <button
                *ngFor="let btn of columnButtons(buttons, col, colCount)"
                type="button"
                [class.active]="statusActive(btn)"
                class="btn btn-block"
                [ngClass]="'btn-outline-'+btn.colour"
                (click)="changeStatus(btn)"
                [disabled]="form.disabled || closed.value || !canChangeFrom || !canChangeTo(btn)">
                <strong>{{ btn.label | translate }}</strong>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #statusButtons2 let-buttons="buttons" let-colCount="colCount" let-wide="wide">
    <div *ngIf="!isPublic && form.enabled && !closed.value" class="row" [class.justify-content-between]="wide">
        <div *ngFor="let dum of columnGenerator(colCount); let col=index; first as isFirst"
            class="col-md-6 col-lg-4 pt-md-0" [class.pt-2]="!isFirst">
            <button *ngFor="let btn of columnButtons(buttons, col)" type="button" [class.active]="statusActive(btn)"
                class="btn btn-block" [ngClass]="'btn-outline-'+btn.colour" (click)="changeStatus(btn)"
                [disabled]="closed.value || !canChangeFrom || !canChangeTo(btn)">
                <strong>{{ btn.label | translate }}</strong>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #tabHeader2>
    <ng-container *ngTemplateOutlet="tabHeader"></ng-container>
</ng-template>

<ng-template #errorsDialog>
    <h5 mat-dialog-title>{{ 'JobError.PleaseFix' | translate }}</h5>
    <div mat-dialog-content>
        <ul class="list-unstyled">
            <li *ngFor="let err of job.errors">{{ err.errorId + ' ' + err.description }} </li>
        </ul>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>{{ 'System.Ok' | translate }}</button>
    </div>
</ng-template>

<ng-template #changeNextAction>
    <h5 mat-dialog-title>{{ 'Job.NextAction' | translate }}</h5>
    <div mat-dialog-content [formGroup]="form">
        <ngb-datepicker (dateSelect)="nextActionSelected($event)" [startDate]="nextActionZZ()" formControlName="nextAction"> <!-- [minDate]=minDate -->
        <!-- (ngModelChange)="onDateChange($event)" -->
        </ngb-datepicker>
        <div class="row">
            <abi-form-field label="Reason" [horizontal]="false" cols="col-12">
                <textarea formControlName="nextActionReason"></textarea>
            </abi-form-field>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">{{ 'System.Cancel' | translate }}</button>
        <button [disabled]="nextActionReason.invalid" mat-button [mat-dialog-close]="true">{{ 'System.Ok' | translate }}</button>
    </div>
</ng-template>


<ng-template #editReasonBody>
    <p>{{ editReasonBodyText | translate }}</p>
    <textarea
        class="form-control"
        [(ngModel)]="editReasonText"
        name="editReasonText"
        id="editReasonText"
        rows="5"
        ></textarea>
</ng-template>

<!-- open this fullscreen on tablet/mobile -->
<ng-template #signatureDialogBody>
    <div class="row" [formGroup]="currentHoldGroup">
        <div class="col-12">
            <div class="row">
                <abi-form-field label="Contact.Contact" cols="col-12" [horizontal]="false">
                    <div class="input-group" #widthReferenceElement>
                        <input abiTypeahead [abiCustomerContact]="job.customerId" formControlName="contactId" [codeOnly]="true" [codeValueProperty]="'contactId'"/>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" (click)="openContactDialog()">New</button>
                        </div>
                    </div>
                </abi-form-field>

                <!-- Disabled for now until later go-ahead -->
                <!-- <abi-gps-tracking-field cols="col-12" formControlName="gpscoordinates"></abi-gps-tracking-field> -->

                <abi-form-field label="Signature" [horizontal]="false" cols="col-12">
                    <signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>
                </abi-form-field>

                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-outline-primary" (click)="clearSignature()">Clear</button>
                </div>
            </div>
        </div>
    </div>
    <!-- <pre>{{ currentHoldGroup?.value | json}}</pre> -->
</ng-template>
